import React, { useState, useEffect, useCallback } from "react";
import { useHistory } from "react-router";
import { useSnackbar } from "notistack";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import { useData } from "../../../../components/firebase/DataProvider";
import { firefunctions } from "../../../../components/firebase/FirebaseProvider";
import currency from "../../../../utils/currency";

function Bayar({
  subcarts,
  boolInvalidJumlah,
  loadDebounce,
  loadDelivery,
  setBatalkan,
  isUniqueCode,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const { profil, global_settings, cart, configuration, level, preorderUtils } =
    useData();
  const history = useHistory();
  const [transaksi, setTransaksi] = useState({});
  const [pakaiKredit, setPakaiKredit] = useState(false);
  const [visible, setVisible] = useState(false);
  const [popupKonfirmasi, setPopupKonfirmasi] = useState(false);
  const [password, setPassword] = useState();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const getTotalTransaksiSeller = useCallback(async () => {
    const transaksi = firefunctions.httpsCallable("getTotalTransaksiSeller");
    const res = await transaksi({ user_id: profil.id });
    setTransaksi(res.data);
  }, [profil.id]);

  useEffect(() => {
    getTotalTransaksiSeller();
  }, []);

  const handleCheckout = async () => {
    if (global_settings.disable_order_creation === true) {
      return enqueueSnackbar(
        "Mohon Maaf, Saat ini Tokorame tidak menerima pesanan baru",
        { variant: "error" }
      );
    }
    if (boolInvalidJumlah) {
      return enqueueSnackbar(
        "Terdapat item dengan jumlah melebihi stok yang ada!",
        { variant: "error" }
      );
    }

    if (pakaiKredit) {
      return setVisible(true);
    }

    try {
      setLoading(true);
      const generateOrderTransactionToken = firefunctions.httpsCallable(
        "generateOrderTransactionToken"
      );
      const response = await generateOrderTransactionToken({
        type: "webseller",
        mode: !level?.is_active
          ? "register_by_order"
          : cart?.tipe_order !== "normal"
          ? cart?.tipe_order
          : "",
        payment:
          cart?.is_payment_code !== "midtrans"
            ? `moota-${cart?.is_payment_code}`
            : "default",
      });

      if (response?.data?.token) {
        if (response?.data?.mode === "free") {
          return history.push(`/transaksi/transaksilist/sellerapp/tokorame`);
        } else {
          // console.log("lwt");
          if (response?.data?.provider === "moota") {
            return history.push(`/moota/${response?.data?.token}`);
            // console.log("lwt1");
            // return setDialogMoota({
            //   open: true,
            //   token: response?.data?.token,
            // });
          } else {
            // console.log("lwt2");
            return history.push(`/payment/${response?.data?.token}`, {
              goBack: "/transaksi/transaksilist/sellerapp/tokorame",
            });
          }
        }
      } else {
        enqueueSnackbar(response.data);
        setLoading(false);
      }
    } catch (e) {
      enqueueSnackbar(e.message, {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const payWithKredit = async () => {
    if (loading) {
      return;
    }
    if (!password) {
      return setError("Password wajib diisi!");
    }

    try {
      setLoading(true);
      const validatePassword = firefunctions.httpsCallable("validatePassword");

      const validate = await validatePassword({
        password,
      });
      if (validate?.data?.status) {
        const callPayWithCredit = firefunctions.httpsCallable("payWithKredit");

        const response = await callPayWithCredit();

        if (response.data.orderId) {
          enqueueSnackbar("Pembayaran berhasil dilakukan!");
        }
      }
      setLoading(false);
      setVisible(false);
    } catch (e) {
      setError(e.message);
      setLoading(false);
    }
  };

  const total = subcarts.reduce?.(
    (total, [key, value]) => {
      let data = 0;
      let data_dp = 0;
      let total_alamat = total.total_alamat;
      let is_ready = total.is_ready;
      let is_voucher = total.is_voucher;
      let bayar = total.bayar;
      let totalTagihan = 0;
      let totalDownPayment = total.totalDownPayment;
      if (value.checked === "Y") {
        data = value.total_tagihan;
        data_dp = value.nilai_dp;
        total_alamat = total.total_alamat + 1;
        is_ready =
          total.is_ready &&
          ((value.biaya_pengiriman_before && value.biaya_pengiriman >= 0
            ? true
            : false) ||
          (value.resi_otomatis_mp &&
            value.resi_otomatis_mp_kurir &&
            value.resi_otomatis_mp_resi)
            ? true
            : false);
        is_voucher =
          value?.nilai_voucher && value?.promo_voucher ? true : false;
        totalTagihan = data + total.totalTagihan;
        totalDownPayment = total.totalDownPayment + data_dp;
        bayar =
          total.bayar +
          data +
          (value.biaya_pengiriman ?? 0) +
          (value.asuransi_pengiriman ?? 0) +
          (value.nilai_infaq ?? 0) +
          (isUniqueCode ?? 0);
      }

      return {
        bayar,
        is_ready,
        is_voucher,
        total_alamat,
        totalTagihan,
        totalDownPayment,
      };
    },
    {
      bayar: 0,
      total_alamat: 0,
      is_ready: true,
      is_voucher: false,
      totalTagihan: 0,
      totalDownPayment: 0,
    }
  );

  const handleConfirm = () => {
    if (!level?.is_active) {
      if (total.totalTagihan >= configuration.registration_fee[level.level]) {
        handleCheckout();
        return;
      } else {
        enqueueSnackbar("minimal belanja kurang untuk aktivasi akun", {
          variant: "error",
        });
        setPopupKonfirmasi(false);
        return;
      }
    }
    handleCheckout();
  };
  // console.log(
  //   !total.is_ready,
  //   total.is_voucher ? total.bayar < 0 : total.bayar <= 0,
  //   loadDebounce,
  //   loadDelivery,
  //   loading
  // );
  return (
    <>
      {/* <div
        style={{
          position: "fixed",
          backgroundColor: "white",
          bottom: 0,
          maxWidth: "100%",
          width: "960px",
          left: "auto",
          right: "auto",
        }}
      > */}
      <div
        style={{
          paddingRight: "20px",
          paddingLeft: "20px",
          paddingTop: "7.5px",
          paddingBottom: "10px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>
          <Typography
            style={{
              fontSize: 12.3,
              fontWeight: "bold",
              textTransform: "capitalize",
            }}
          >
            {cart?.tipe_order == "preorder" &&
            preorderUtils?.down_payment_option
              ? "Total Down Payment"
              : "Total Pembayaran"}
          </Typography>{" "}
          <Typography
            style={{
              fontSize: 13,
              fontWeight: "bold",
              textTransform: "capitalize",
            }}
            color="secondary"
          >
            {currency(
              preorderUtils?.down_payment_option && total?.totalDownPayment > 0
                ? total?.totalDownPayment
                : total?.bayar
            )}
          </Typography>{" "}
          <Typography
            style={{
              fontSize: 12,
            }}
          >
            {total?.total_alamat} orderan
          </Typography>
        </div>
        <div style={{ alignSelf: "flex-end" }}>
          <Button
            // style={{ textTransform: "capitalize" }}
            onClick={() => setPopupKonfirmasi(true)}
            // fullWidth
            disabled={
              !total.is_ready ||
              (total.is_voucher ? total.bayar < 0 : total.bayar <= 0) ||
              loadDebounce ||
              loadDelivery ||
              loading ||
              cart?.is_payment_code === undefined ||
              cart?.is_payment_name === undefined
            }
            color="primary"
            size="small"
            variant="contained"
          >
            Bayar Sekarang
          </Button>
        </div>
      </div>
      {/* </div> */}
      <Dialog open={popupKonfirmasi} onClose={() => setPopupKonfirmasi(false)}>
        <DialogTitle>
          <Typography style={{ fontSize: 18 }}>Konfirmasi!</Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Typography style={{ fontSize: 16 }}>
            Mohon dipastikan alamat pengiriman dan produk yang dipilih sudah
            sesuai.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            // fullWidth
            variant="text"
            // color="secondary"
            onClick={() => setPopupKonfirmasi(false)}
            disabled={loading}
            size="small"
          >
            Batal
          </Button>
          <Button
            // fullWidth
            variant="text"
            // color="primary"
            size="small"
            onClick={handleConfirm}
            disabled={loading}
          >
            Lanjutkan
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={visible} onClose={() => setVisible(false)}>
        <DialogTitle>Konfirmasi Password</DialogTitle>
        <DialogContent>tes</DialogContent>
        <DialogActions>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={payWithKredit}
            disabled={loading}
          >
            Bayar Dengan Kredit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Bayar;
